import { render, staticRenderFns } from "./review-detail.vue?vue&type=template&id=15c53b02&scoped=true&"
import script from "./review-detail.vue?vue&type=script&lang=js&"
export * from "./review-detail.vue?vue&type=script&lang=js&"
import style0 from "./review-detail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./review-detail.vue?vue&type=style&index=1&id=15c53b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c53b02",
  null
  
)

export default component.exports